import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Configuration} from '@shared/models/configuration';

@Component({
    standalone: false,
    selector: 'app-people-and-roles-dialogue',
  templateUrl: './people-and-roles-dialogue.component.html',
  styleUrls: ['./people-and-roles-dialogue.component.scss']
})
export class PeopleAndRolesDialogueComponent implements OnInit, IDialogView {
  data: DialogModel;
  sourceType: any;
  invalidateSubject: any = new InvalidateSubject();
  private fieldDefinition: any;

  onOkClicked(): any {
    return true;
  }
  constructor() {
  }

  ngOnInit(): void {
    this.sourceType = this.data.input.sourceType;
    this.fieldDefinition = this.data.input.fieldDefinition;
    const config = Configuration.getSmartGridConfig(this.sourceType);
    if (this.fieldDefinition && this.fieldDefinition.metaData && this.fieldDefinition.metaData['ItemsUrlIndex']) {
      config.ItemsUrlIndex = +this.fieldDefinition.metaData['ItemsUrlIndex'];
    } else {
      config.ItemsUrlIndex = 0;
    }
    // console.log(config);
    config.Parameters['ItemId'] = this.data.input.itemId;
    config.Parameters['NodeId'] = this.data.input.currentNodeId;
  }

  onGridCellValueChange($event: any) {

  }
}
